import { put, call, fork, select } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';
import { createPasswordRequest } from '../requesters/createPasswordRequester';
import {
  createPasswordSuccess,
  createPasswordFailure,
  validatePassword
} from 'actions/createNewPasswordActions';
import { CREATE_PASSWORD_REQUEST } from 'constants/actionTypes';
import { push } from 'react-router-redux';

/**
 * Change Password API call.
 * On success, dispatch createPasswordSuccess
 * On failure, dispatch createPasswordFailure with the response error code
 * @param {String} email
 * @param {String} password
 * @param {String} token
 * @return {void}
 */
export function* requestCreatePassword(email, password, token) {
  try {
    yield call(createPasswordRequest, email, password, token);
    yield put(push('/reset_password_success'));
    yield put(createPasswordSuccess());
  } catch (error) {
    yield put(createPasswordFailure('createPasswordFailure'));
  }
}

export function* processCreatePassword() {
  yield put(validatePassword());
  const state = yield select();
  if (!state.createNewPassword.errorText) {
    yield call(requestCreatePassword,
      state.createNewPassword.email,
      state.createNewPassword.password,
      state.createNewPassword.token);
  } else {
    yield put(createPasswordFailure(state.createNewPassword.errorText));
  }
}

/**
 * Waits for the return of the LOGIN_REQUEST action event, pulls username and password
 * from appState, and calls the login saga
 * @return {void}
 */
export function* createPasswordWatcher() {
  yield* takeEvery(CREATE_PASSWORD_REQUEST, processCreatePassword);
}

/**
 * Uses fork to start multiple watchers in parallel
 * @return {void}
 */
export default function* rootSaga() {
  yield fork(createPasswordWatcher);

}
